<template>
  <v-app-bar fixed clipped-top app class="thick-border-top">
    <h2 class="font-weight-light">{{ tenantOrganisation.name || "" }}</h2>
    <v-spacer></v-spacer>
    <v-menu transition="slide-y-transition" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="darken-2">
          <v-icon class="pr-2">language</v-icon>
          ({{ $locale_bcp47(locale) }})
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in locales" :key="i">
          <v-btn text md12 @click="changeLocale(item.key)" class="darken-2">{{ item.text }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "HeaderEnrolment",

  data() {
    return {
      locales: this.$dd_locales()
    }
  },

  computed: {
    tenantOrganisation() {
      return this.$store.getters["master/tenantOrganisation"]
    },
    locale: {
      get() {
        return this.$store.getters["settings/fe_locale"]
      },
      set(value) {
        this.$updateSetting("fe_locale", value)
        this.$i18n.locale = value
      }
    }
  },

  methods: {
    changeLocale(val) {
      let path = this.$router.currentRoute.path
      path = path.replace("/embed/" + this.locale + "/", "/embed/" + val + "/")

      this.$router.push(path)

      this.$updateSetting("fe_locale", val)
      this.$i18n.locale = val
      this.locale = val
    }
  }
}
</script>
